import { Spinner } from '@shopify/polaris';

export default function AppLoading(props) {
  return (
    <div {...props}>
      <Spinner size='small' />
    </div>
  );
}
